<script lang="ts">
  import RoutingControls from './components/RoutingControls.svelte';
  import FilterControls from './FilterControls.svelte';
  import IframeSmartmodel from './components/IframeSmartmodel.svelte';
  import type { SmartmodelMessage } from './components/types/smartmodel-message';
  import type { Config, FilterType, FilterValue } from './global';
  import FavoritesControls from './components/FavoritesControls.svelte';
  import { constraintsWritable } from './stores/config.store';
  import { sendMessageWritable } from './stores/iframe-communication.store';

  const fetchConfig = fetch('config/config.json')
          .then(response => response.json())
          .then((config: Config) => {
            appUrl = config.appUrl;
            buildings = config.buildings ?? [];
            enabledFilterControls = config.enabledFilterControls ?? [];
            favoritesList = config.favoritesList ?? [];
            styles = config.styles;
            constraintsWritable.update(c => ({...c, ...config.constraints ?? {}}))
          });

  let appUrl: string;
  let buildings: string[];
  let enabledFilterControls: FilterType[];
  let favoritesList: string[];
  let styles: string[];
  let iframeSmartmodel: IframeSmartmodel;

  const onIFrameMessage = (message: CustomEvent<SmartmodelMessage>) => {
    switch (message.detail.receiver) {
      case 'status':
        if (message.detail.data === 'FAVORITES_READY') {
          sendMessageWritable.set({
            receiver: 'favorites',
            data: favoritesList,
          });
        }
        // if (message.detail.data === 'SELECT_READY') {
        //   iframeSmartmodel.sendMessage({
        //       receiver: 'select',
        //       data: '1446',
        //     });
        // }
        break;
      case 'favorites':
        console.log(message.detail.data);
        favoritesList = message.detail.data;
        break;
    }
    console.log(message.detail);
  };

  const sendFilterToSmartmodel = (event: CustomEvent<FilterValue>) => {
    console.log(event.detail);
    sendMessageWritable.set({receiver: 'filter', data: event.detail});
  };

  const sendMessageToSmartmodel = (event: CustomEvent<SmartmodelMessage>) => {
    sendMessageWritable.set(event.detail);
  };
</script>

{#await fetchConfig}
  <p>Loading</p>
{:then _}
  <div class="accordion accordion-flush mb-3">
    <div class="accordion-item">
      <h2 class="accordion-header" id="navigationHeading">
        <button
                class="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navigationControls"
                aria-expanded="true"
                aria-controls="navigationControls">
          Nawigacja
        </button>
      </h2>
      <div id="navigationControls" class="accordion-collapse collapse show" aria-labelledby="navigationHeading">
        <div class="accordion-body">
          <RoutingControls {buildings} on:navigate="{sendMessageToSmartmodel}"/>
        </div>
      </div>
    </div>
    <div class="accordion-item">
      <h2 class="accordion-header" id="filterControlsHeading">
        <button
                class="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#filterControls"
                aria-expanded="false"
                aria-controls="filterControls">
          Filtry
        </button>
      </h2>
      <div id="filterControls" class="accordion-collapse collapse" aria-labelledby="filterControlsHeading">
        <div class="accordion-body">
          <FilterControls {enabledFilterControls}
                          {styles}
                          on:filterValue="{sendFilterToSmartmodel}"/>
        </div>
      </div>
    </div>
    <div class="accordion-item">
      <h2 class="accordion-header" id="favoritesControlsHeading">
        <button
                class="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#favoritesControls"
                aria-expanded="false"
                aria-controls="favoritesControls">
          Ulubione / schowek
        </button>
      </h2>
      <div id="favoritesControls" class="accordion-collapse collapse" aria-labelledby="favoritesControlsHeading">
        <div class="accordion-body">
          <FavoritesControls favorites="{favoritesList}" on:select="{sendMessageToSmartmodel}"/>
        </div>
      </div>
    </div>
  </div>
  <IframeSmartmodel on:iframeMessage="{onIFrameMessage}"
                    appUrl="{appUrl}"
                    bind:this="{iframeSmartmodel}"/>

{/await}

<style lang="scss" global>
  @import 'styles/main';
</style>
